// Footer image opens Crisp chat while hiding the default launcher.
(function () {
    var TRIGGER_SELECTOR = '[data-footer-chat-trigger]';
    var CLOSE_BUTTON_SELECTOR = '[data-footer-chat-close]';
    var HIDDEN_CLASS = 'footer-chat-trigger--hidden';
    var hooksRegistered = false;

    function hideTrigger(trigger) {
        if (!trigger) {
            return;
        }

        trigger.classList.add(HIDDEN_CLASS);
    }

    function ensureCrispQueue() {
        window.$crisp = window.$crisp || [];
        return window.$crisp;
    }

    function hideLauncher() {
        ensureCrispQueue().push(['do', 'chat:hide']);
    }

    function openChat() {
        var queue = ensureCrispQueue();
        queue.push(['do', 'chat:show']);
        queue.push(['do', 'chat:open']);
    }

    function registerHooks() {
        if (hooksRegistered) {
            return;
        }

        hooksRegistered = true;

        var reHide = function () {
            hideLauncher();
        };

        var queue = ensureCrispQueue();
        queue.push(['on', 'chat:closed', reHide]);
        queue.push(['on', 'session:loaded', reHide]);
    }

    function bindClose(trigger) {
        var closeButton = trigger.querySelector(CLOSE_BUTTON_SELECTOR);
        if (!closeButton) {
            return;
        }

        closeButton.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            hideTrigger(trigger);
        });
    }

    function bindTrigger(trigger) {
        if (!trigger || trigger.dataset.chatTriggerBound === 'true') {
            return;
        }

        trigger.dataset.chatTriggerBound = 'true';

        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            openChat();
        });

        trigger.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openChat();
            }
        });

        bindClose(trigger);
    }

    function init() {
        var triggers = document.querySelectorAll(TRIGGER_SELECTOR);
        if (!triggers.length) {
            return;
        }

        triggers.forEach(bindTrigger);
        registerHooks();
        hideLauncher();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', init);
})();
